export default __webpack_public_path__ + "static/1736-1ca80d3da4cd72ef981964683aba8e77.gif";